// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader___dasC"};